import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Cloudinary } from '@cloudinary/url-gen';
import { CursorService } from './services/cursor_animation/cursor.service';
import { CursorColorService } from './services/cursorColor/cursor-color.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'zumera';
  loading: boolean | undefined;
  isMaintenanceMode = false;
  /** Site-wide maintenance mode for all hosts, including the Vercel deployment. */
  private maintenanceEnabled = true;
  private readonly maintenanceExemptRoutes = [
    '/benin-city',
    '/executive-jobs',
    '/join-our-tribe',
  ];

  constructor(
    private cursorService: CursorService,
    private cursorColorService: CursorColorService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const cld = new Cloudinary({ cloud: { cloudName: 'dv3rvc1by' } });

    if (this.maintenanceEnabled) {
      this.updateMaintenanceMode(this.router.url);
    }

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (this.maintenanceEnabled) {
          this.updateMaintenanceMode(event.urlAfterRedirects);
        }
      });
  }

  ngAfterViewInit(): void {
    this.cursorService.ensureInitialized();
  }

  private updateMaintenanceMode(url: string): void {
    const path = url.split('?')[0] || '/';
    const isJoinOurTribeSlug = path.startsWith('/join-our-tribe/');
    this.isMaintenanceMode =
      !this.maintenanceExemptRoutes.includes(path) && !isJoinOurTribeSlug;
  }
}
